var isDocReady = false;
$(document).ready(function() {
  isDocReady = true;
  var filter = $('#search_order_type').val();
  var order = $('#search_order_value').val();
  var alertInput = $('#search_alert_level');

  if (alertInput.length) {
    if (alertInput.val() != '') {
      $("[data-type=\"" + alertInput[0].id + "\"]").find('.arrow').removeClass('arrow_double').addClass('arrow_' + alertInput.val());
    } else {
      $("[data-type=\"" + alertInput[0].id + "\"]").find('.arrow').addClass('arrow_double');
    }
  } else {
    $("[data-type=\"" + filter + "\"]").find('.arrow').removeClass('arrow_double').addClass('arrow_' + order);
  }

  $(document).on('click', '.js-search-filter', function(e){
    e.preventDefault();

    filter = $('#search_order_type').val();
    order = $('#search_order_value').val();
    var arrow = $(this).find('.arrow');

    $('.arrow').addClass('arrow_double').removeClass('arrow_asc').removeClass('arrow_desc');

    if (filter && order) {
      arrow.addClass('.arrow_' + order);

      if (order === 'desc') {
        arrow.removeClass('arrow_double').addClass('arrow_asc');
        $('#search_order_value').val('asc');
      }
      else {
        arrow.removeClass('arrow_double').addClass('arrow_desc');
        $('#search_order_value').val('desc');
      }

      $('#search_order_type').val($(this).data('type'));
      $('#search_order_type').closest('form').submit();
    } else {
      arrow.addClass('.arrow_' + alertInput.val());

      if (alertInput.val() === 'desc') {
        arrow.removeClass('arrow_double').addClass('arrow_asc');
        $('#search_alert_level').val('asc');
      }
      else {
        arrow.removeClass('arrow_double').addClass('arrow_desc');
        $('#search_alert_level').val('desc');
      }

      $('#search_alert_level').closest('form').submit();
    }
  });

  $(document).on('click', '.o-js-funds_filters_more', function(e){
    e.preventDefault();

    var funds_filters = $('.o-js-funds_filters');

    funds_filters.slideToggle();
    funds_filters.toggleClass('is-active');

    if (funds_filters.hasClass('is-active')) {
      $(this).text($(this).data('less'));
    } else {
      $(this).text($(this).data('more'));
    }
  });

  $(document).on('click', '.o-js-funds_filters-sub-trigger', function(e){
    e.preventDefault();

    $('.o-js-funds_filters-sub').slideUp();
    $(this).next('.o-js-funds_filters-sub').slideDown();
  });

  $(document).on('click', '.o-js-check_boxes_uniq input', function(e){
    if ($(this).prop('checked')) {
      if ($(this).parent().parent().next().length) {
        $(this).parent().parent().next().find('input').prop('checked', false);
      }
      if ($(this).parent().parent().prev().length) {
        $(this).parent().parent().prev().find('input').prop('checked', false);
      }
    }
  });
});

function onGoogleLoad() {
  if (isDocReady)
    initAutocomplete();
  else
    $(document).ready(initAutocomplete);
}

function initAutocomplete() {
  var input = document.querySelector('.js-autocomplete');
  var options = {
    language: 'fr',
    components: 'country:fr',
    types: ['(cities)']
  };
  var autocomplete = new google.maps.places.Autocomplete(input, options);
}
